import { render, staticRenderFns } from "./CertificateManagement.vue?vue&type=template&id=00583162&scoped=true"
import script from "./CertificateManagement.vue?vue&type=script&lang=js"
export * from "./CertificateManagement.vue?vue&type=script&lang=js"
import style0 from "./CertificateManagement.vue?vue&type=style&index=0&id=00583162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00583162",
  null
  
)

export default component.exports